export default __webpack_public_path__ + "static/media/PBERHEE.fff44276.png";